import { TOKEN_LOGOUT } from "../../ActionTypes";

export const tokenLogout = (history) => (dispatch) => {
  sessionStorage.removeItem("token");
  dispatch({ type: TOKEN_LOGOUT });
  history.push("/");
};
export const tokenLoginLogout = () => (dispatch) => {
  // sessionStorage.removeItem("token");
  dispatch({ type: TOKEN_LOGOUT });
  // history.push("/");
};
